export interface PageableModel {
  size: number;
  page: number;
  sort?: string;
  direction?: string;
}
